import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, Search, ShoppingCart, User } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function MobileNav() {
  const { count } = useCart();
  const { pathname } = useLocation();
  const items = [
    { to: "/", icon: Home, label: "Ana Sayfa", id: "home" },
    { to: "/urunler", icon: LayoutGrid, label: "Kategoriler", id: "categories" },
    { to: "/urunler?ara=1", icon: Search, label: "Arama", id: "search" },
    { to: "/sepet", icon: ShoppingCart, label: "Sepet", id: "cart" },
    { to: "/hesap", icon: User, label: "Hesabım", id: "account" },
  ];
  return (
    <nav data-testid="mobile-bottom-nav" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-stone-200 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
      <div className="grid grid-cols-5">
        {items.map(({ to, icon: Icon, label, id }) => (
          <Link key={id} to={to} data-testid={`mobile-nav-${id}`} className={`relative flex flex-col items-center py-2.5 ${pathname === to ? "text-forest" : "text-stone-400"}`}>
            <Icon className="w-5 h-5" />
            <span className="text-[10px] mt-0.5 font-medium">{label}</span>
            {id === "cart" && count > 0 && <span className="absolute top-1 right-1/2 translate-x-4 bg-terra text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">{count}</span>}
          </Link>
        ))}
      </div>
    </nav>
  );
}
